const styles = (theme) => ({
  chartContainer: {
    marginTop: `${theme.spacing(5)}px !important`,
    marginBottom: `${theme.spacing(3)}px !important`,
  },
  tableContainer: {
    marginTop: theme.spacing(4),
  },
  tableSubtitle: {
    paddingLeft: theme.spacing(1),
  },
  select: {
    minWidth: '120px !important',
  },
  noBorder: {
    border: 'none !important',
  },
});

export default styles;
